// Shared helper functions
import { UserPermissions } from '../constants/userPermissions';

// Helper functions for ReusableTable component
// Helper function to extract numeric value from string
export const extractNumericValue = (value: any): number => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    // Remove currency symbols, commas, and percentage signs, then parse
    const numericString = value.replace(/[$₹,%]/g, '');
    const parsed = parseFloat(numericString);
    return isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

// Helper function to format total value based on original format
export const formatTotalValue = (total: number, sampleValue: any): string => {
  if (typeof sampleValue === 'string') {
    if (sampleValue.includes('₹')) {
      return `₹${total.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    }
    if (sampleValue.includes('%')) {
      return `${total.toFixed(1)}%`;
    }
  }
  return total.toLocaleString();
};

// TODO : when marketplace integration is done, locale should be dynamically determined
export const getFormattedDate = (dateString: number | string) =>
  new Date(dateString).toLocaleDateString('en-IN', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

/**
 * Check if the user's permissions include EDIT or ALL access.
 * Used to gate edit/create/delete actions across the app.
 */
export const hasEditPermission = (userPermissions: string[] = []): boolean =>
  userPermissions.includes(UserPermissions.EDIT) || userPermissions.includes(UserPermissions.ALL);

/**
 * Determine if the user can edit based on their permissions.
 */
export const canUserEdit = (permissions?: string[] | null): boolean =>
  permissions != null && hasEditPermission(permissions);

/**
 * Resolve permissions for a user role from the roles list.
 * Falls back to ['VIEW'] if the role is not found.
 */
export const resolveUserPermissions = (
  userRole: string,
  roles: { userRole: string; permissions: string[] }[]
): string[] => {
  const matchedRole = roles.find((r) => r.userRole === userRole);
  return matchedRole?.permissions ?? [UserPermissions.VIEW];
};
